export const CHANGE_INVOICES_VERSION = 'CHANGE_INVOICES_VERSION';
